import {
    getBanks,
    deleteBank,
    createBank,
    updateBank,
    getAllBanks
} from '../../../services/BankService';
import {
    CONFIRMED_GET_BANKS
} from './BankTypes';

export function getBanksAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'BANK_LOADING' });
        getBanks(currentPage, pageSize, searchTerm, filterQuery)
            .then((response) => {
                dispatch(confirmedGetBanksAction(response.data.data));
            })
            .catch(() => {
                dispatch(confirmedGetBanksAction({ rows: [], count: 0, pages: 1 }));
            });
    };
}

export function getAllBanksAction(filterQuery) {
    return (dispatch, getState) => {
        getAllBanks(filterQuery).then((response) => {
            dispatch(confirmedGetBanksAction(response.data.data));
        });
    };
}

export function confirmedGetBanksAction(data) {
    return {
        type: CONFIRMED_GET_BANKS,
        payload: data,
    };
}

export function deleteBankAction(id, history) {
    return (dispatch, getState) => {
        return deleteBank(id).then((response) => {
            return response;
        });
    };
}

export function createBankAction(data) {
    return () => {
        return createBank(data).then((response) => {
            return response;
        });
    };
}

export function updateBankAction(id, data) {
    return () => {
        return updateBank(id, data).then((response) => {
            return response;
        });
    };
}

